<template lang="pug">
.v-news-grid.news-grid(v-if="data" :id="data?.id")
	.news-grid__header
		.news-grid__control.tags
			.tags__items(v-if="data.tabs")
				.tags__item(v-for="tab in data.tabs" @click="handleTabClick(tab)" :class="{'active': tab.active}") {{tab.title}}
	template(v-if="data.items && data.items.length")
		.news-grid__items
			.news-grid__item(v-for="item in data.items")
				v-news-card(:card="item")
		v-page-nav.news-grid__page-nav(:page="data.page" @navigate="navigate")
</template>

<script>

import sourceMixin from "./mixins/v-mixin-source.vue";
import isMobMixin from "./mixins/v-mixin-is-mob.vue";
import breakpoints from "../scripts/breakpoints.js";

export default {

	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			data: null,
			active: null,
			page: null
		}
	},

	methods: {
		dataSet(data, options = {}) {
			this.data = data;
			this.active = data.tabs?.find(item => item.active);
			this.page = data.page;
			if (window.location.pathname.indexOf('/local/') < 0 && options.updateUrl) {
				window.history.replaceState(null, null, data.remote);
			}
		},

		requestDataLoad(dataSetOptions) {
			if (this.loading) {
				return;
			}
			this.loading = true;
			this.dataLoad({
				url: this.data.remote,
				delay: false,
				method: 'POST',
				data: {
					id: dataSetOptions.id,
					page: dataSetOptions.page || this.page
				},
			}, dataSetOptions);
		},

		handleTabClick(item) {
			this.active = item;
			this.requestDataLoad({id: item.id, updateUrl: true});
		},

		navigate(page) {
			this.page.offset = page.offset;
			this.page.limit = page.limit;
			this.requestDataLoad({id: this.active?.id, updateUrl: true});
		},
	}
}

</script>